<template>
  <div class="check-list">
    <el-table
      ref="multipleTable"
      :data="checkList"
      tooltip-effect="dark"
      style="width: 100%"
      class="common-edit-button"
    >
      <el-table-column
        prop="checkName"
        label="审核类型"
        :show-overflow-tooltip="true"
        width="200px"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="checkCode"
        label="code"
        :show-overflow-tooltip="true"
        width="200px"
      >
      </el-table-column> -->
      <el-table-column
        prop="createTime"
        label="创建时间"
        :show-overflow-tooltip="true"
        width="300px"
      >
      </el-table-column>
      <el-table-column label="是否启用">
        <template slot-scope="scope">
          <el-switch
            :width="42"
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="0"
            inactive-value="1"
            @change="statusChange(scope.row)"
            :disabled="!userPermissions.includes('sc:schoolcheck:edit')"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 绑定 -->
            <el-button
              type="warning"
              size="small"
              icon="el-icon-edit"
              @click="bindJob(scope.row)"
              v-hasPermi="'sc:schoolcheck:edit'"
            >修改
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 绑定 -->
    <bindJobDialog
      :bindJobShow.sync="bindJobShow"
      :checkInfo="checkInfo"
      v-if="bindJobShow"
    />
  </div>
</template>

<script>
import bindJobDialog from "../bind-job/bind-job.vue";
export default {
  data() {
    return {
      checkInfo: null,
      bindJobShow: false,
      userPermissions: [],
    };
  },
  props: {
    checkList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    bindJobDialog,
  },
  inject: ["refresh"],
  created() {
    this.userPermissions = window.localStorage.getItem("menuPermissions");
  },
  methods: {
    bindJob(item) {
      this.bindJobShow = true;
      this.checkInfo = item;
    },
    statusChange(item) {
      let { id, status } = item;
      this.post(this.$url.updateSchoolCheck, {
        id,
        status,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("切换状态成功");
          // 刷新列表
          this.refresh();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 修改宿舍
    // editcheck(item) {
    //   // console.log(item);
    //   this.checkInfo = item;
    //   this.editShow = true;
    // },
  },
};
</script>

<style>
@import "./checkList.scss";
</style>
